<script lang="ts">
	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { onMount } from 'svelte';
	import type { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { TeaserTouchPoint } from '../../../domain/teaser/TeaserUtils.ts';
	import { getHeadlineUpdates } from '../../../services/teaser/HeadlineHelper.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';
	import { toSignUpSheet } from '../../../domain/SheetData.ts';

	let { teaserContent, teaserType, teaserSize, teaserTouchPoint }: {
		teaserContent: TeaserContent,
		teaserType: TeaserType,
		teaserSize: string,
		teaserTouchPoint: TeaserTouchPoint | undefined
	} = $props();

	let headline = $state(teaserContent.heading);

	let teaser: Element;
	let trackingService: TrackingService;

	onMount(() => {
		trackingService = new TrackingService();
		watchForHeadlineUpdates();
		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize);
	});

	const watchForHeadlineUpdates = () => {
		const intervalId = window.setInterval(() => {
			if (teaserContent.countdown) {
				headline = getHeadlineUpdates(teaserContent.countdown, teaserContent.heading, teaserType, intervalId);
			}
		}, 1000);
	};
</script>
<div
	bind:this={teaser}
	id="teaser-container"
	data-testid="up-teaser-s-container"
	data-oc-sheet-v1-create={JSON.stringify(toSignUpSheet(teaserType, teaserContent, teaserTouchPoint))}
	onenterViewport={() => trackSeen(trackingService, teaser, teaserContent, teaserType, teaserSize)}
	use:onViewport
>
	<oc-media-object-card-v1
		as-button=""
		background-color="#F0F0F0"
		data-testid="up-teaser-s-card"
		elevation-level="canvas"
		icon="otto-up"
		icon-color="#F00020"
		size="25"
		variant="icon"
	>
		<div aria-hidden="true" id="headline" slot="headline">{headline}</div>
		<div aria-hidden="true" id="subline" slot="subline">{teaserContent?.subheading}</div>
	</oc-media-object-card-v1>

</div>
